import { ENV, PRODUCTION } from '@sigma/env/environments.js';
export function getPageTitle(title) {
    if (!PRODUCTION) {
        return `[${ENV.toUpperCase()}] ${title} | Healed`;
    }
    return `${title} | Healed`;
}
//# sourceMappingURL=getPageTitle.js.map